// Yak&Brew theme JS: cart count, variant selection, FAQ niceties
document.addEventListener('DOMContentLoaded', function() {
  // Update cart count after add-to-cart forms (non-AJAX fallback is fine)
  document.querySelectorAll('form[action="/cart/add"]').forEach(function(form) {
    form.addEventListener('submit', function() {
      var btn = form.querySelector('button[type="submit"]');
      if (btn) { btn.disabled = true; btn.textContent = 'Adding...'; }
    
  // Mobile drawer menu
  var toggle = document.querySelector('.menu-toggle');
  var menu = document.querySelector('.mobile-menu');
  var overlay = document.querySelector('.menu-overlay');
  var closeBtn = document.querySelector('.menu-close');
  function openMenu() {
    menu.classList.add('open');
    if (overlay) overlay.classList.add('open');
    toggle.classList.add('open');
    toggle.setAttribute('aria-expanded', 'true');
    menu.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeMenu() {
    menu.classList.remove('open');
    if (overlay) overlay.classList.remove('open');
    toggle.classList.remove('open');
    toggle.setAttribute('aria-expanded', 'false');
    menu.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
  if (toggle && menu) {
    toggle.addEventListener('click', function() {
      menu.classList.contains('open') ? closeMenu() : openMenu();
    });
    if (closeBtn) closeBtn.addEventListener('click', closeMenu);
    if (overlay) overlay.addEventListener('click', closeMenu);
    menu.querySelectorAll('a').forEach(function(link) {
      link.addEventListener('click', closeMenu);
    });
  }
});
  });
});

// Mobile drawer backdrop: tapping the dimmed area outside the drawer closes it (native drawer behavior)
document.addEventListener('DOMContentLoaded', function() {
  var disclosure = document.querySelector('.menu-disclosure');
  var backdrop = document.querySelector('.menu-backdrop');
  if (!disclosure || !backdrop) { return; }
  backdrop.addEventListener('click', function() {
    disclosure.removeAttribute('open');
  });
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && disclosure.hasAttribute('open')) {
      disclosure.removeAttribute('open');
    }
  });
  disclosure.addEventListener('toggle', function() {
    document.body.style.overflow = disclosure.hasAttribute('open') ? 'hidden' : '';
  });
});
